type Sheet = { name: string; rows: string[][]; truncated: boolean }

/** Splits the server's preview text (`Sheet: <name>` then tab-separated rows) into sheets. */
export function parseSpreadsheetPreview(text: string): Sheet[] {
  const sheets: Sheet[] = []
  // Embedded tabs and newlines are not escaped: this is a text preview, not a workbook editor.
  for (const line of text.split('\n')) {
    if (line.startsWith('Sheet: ') && !line.includes('\t')) sheets.push({ name: line.slice(7), rows: [], truncated: false })
    else if (sheets.length) {
      const sheet = sheets[sheets.length - 1]!
      if (line === '[Preview truncated]') sheet.truncated = true
      else sheet.rows.push(line.split('\t'))
    }
  }
  return sheets
}

export function columnName(index: number): string {
  let name = ''
  for (let value = index + 1; value > 0; value = Math.floor((value - 1) / 26)) {
    name = String.fromCharCode(65 + ((value - 1) % 26)) + name
  }
  return name
}
